import { render, staticRenderFns } from "./VulnerabilityPill.vue?vue&type=template&id=3159ef4a&"
import script from "./VulnerabilityPill.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports